export default __webpack_public_path__ + "static/media/faci03.536c8eca.jpg";